import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { responseIsSuccess } from '../shared/helper-functions';
import { arrayIsDefinedAndContainsKey } from '../shared/array-functions';
import { CONSTANTS } from '../shared/constants';

@Injectable()
export class VacationService {
  private apiUrl: string;
  vacationList: object [];

  constructor(private http: HttpClient) {
    this.apiUrl = environment.api.protocol + environment.api.hostname + environment.api.path;
   }

  /*
   * Get list of pending vacation
   * API endpoint: VacationList?SubID=subscriptionId
  */
  getVacationList(subscriptionId) {
    const route = 'VacationList';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.subscriptionIdQueryParam + '=' + subscriptionId).subscribe(
      (response) => {
      if (responseIsSuccess(response) && response['CMS_SAM_Get_IssueVacation_BySubID']) {
        this.vacationList = response['CMS_SAM_Get_IssueVacation_BySubID'];
      }
    },
    (err: HttpErrorResponse) => {
      this.handleError(err);
  });
  }

  /*
   * Schedule new vacation
   * API endpoint: ScheduleVacation
   * Request Payload: SubID, FromDate, ToDate
  */
  scheduleVacation(subscriptionId, fromDate, toDate): Observable<any> {
    const route = 'ScheduleVacation';
    const payload = {
      SubID: subscriptionId,
      FromDate: fromDate,
      ToDate: toDate
    };
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => { 
      return res;
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
   * Cancel vacation
   * API endpoint: CancelVacation?SubEventID=subscriptionEventId
  */
  cancelVacation(subscriptionEventId): Observable<any> {
    const route = 'CancelVacation';
    return this.http.delete(this.apiUrl + route + '?' + CONSTANTS.api.subscriptionEventIdQueryParam + '=' +  subscriptionEventId)
    .map((res: Response) => {
      return res;
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  private handleError(err:HttpErrorResponse){
    if (err.error instanceof Error) {
      // A client-side or network error occurred
      console.error('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code
      console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/vacation.service.ts